/**
 * Thin client for the zoomnotes-worker. Single endpoint we care about:
 * `POST /suggest`. Build-time env var `VITE_WORKER_URL` baked in by Vite.
 */

import type {
  MeetingContext,
  SuggestResponse,
  TemplateName,
} from './types'

const WORKER_URL =
  (import.meta.env.VITE_WORKER_URL as string | undefined) ??
  'http://localhost:8787'

export interface SuggestArgs {
  template: TemplateName
  notes: string
  meetingContext?: MeetingContext
}

export interface HealthResponse {
  ok: boolean
  service: string
  model: string
  configured: boolean
}

export async function checkHealth(): Promise<HealthResponse> {
  const resp = await fetch(`${WORKER_URL}/health`, { method: 'GET' })
  if (!resp.ok) {
    throw new Error(`worker /health failed (${resp.status})`)
  }
  return (await resp.json()) as HealthResponse
}

export async function suggest(args: SuggestArgs): Promise<SuggestResponse> {
  const resp = await fetch(`${WORKER_URL}/suggest`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(args),
  })

  if (!resp.ok) {
    let message = `worker /suggest failed (${resp.status})`
    try {
      const body = (await resp.json()) as { error?: string }
      if (body.error) message = `${message}: ${body.error}`
    } catch {
      /* response wasn't JSON; use default message */
    }
    throw new Error(message)
  }
  return (await resp.json()) as SuggestResponse
}

export const workerUrl = WORKER_URL
